import React from "react";
import { Button } from "react-bootstrap";

import shareIcn from "../assets/images/TestShare-icon.png";
import TestLogo from "../assets/images/testlogo.png";

const TestCard = ({ item }) => {
  return (
    <div className="popularSeries-card dashboardCard testseriesCard">
      <div className="card itemCard border-bottom-0 mb-2">

        {/* Free/Logo/Live + Share */}
          <div className="d-flex justify-content-between mb-2">
          <div className="d-flex gap-1">
            {item.logo && <img src={TestLogo} className="test-logo me-2" />}
            {item.free && <div className="text-white test-free fw-semibold">Free</div>}
            {item.live && <div className="liveTest fw-semibold">Live</div>}
          </div>

          {item.badgeShield && <img src={shareIcn} className="badge-logo"/>}
        </div>

        {/* Title */}
        <h5 className="small blackText fw-bold mb-2">{item.title}</h5>

          <div className="row">

        <div className="col-12 d-flex gap-2 flex-wrap grayText font11 detailCard ">
          <span className="font11">
            <img src={item.testsIcon} alt="" /> {item.tests} Tests
          </span>

          {item.freeTests && (
            <span className="font11 text-white freegreenBG">
              {item.freeTests} tests free
            </span>
          )}

          <span className="font11">
            <img src={item.attemptsIcon} alt="" /> {item.attempts} Attempts
          </span>

          <span className="font11">
            <img src={item.enrolIcon} /> {item.enrolments}+ Enrolments
          </span>

          <span className="font11">
            <img src={item.langIcon} /> {item.languages.join(", ")}
          </span>
        </div>

      </div>
      </div>

    

      {/* Button */}
      <div className="buttonALign">
       <Button variant="primary" className="w-100 btn-purple startNow fw-bold">
           {item.buttonLabel}
      </Button>
      </div>
    </div>
  );
};

export default TestCard;
